export const langs = {
    en: { nativeName: "English" },
    fr: { nativeName: "Français" },
};